import React from "react";
import { DataTableDefaultCellTemplates, DataTableEventArgs, DataTableState, Icon, ITableColumn } from "../../../../components";
import { formatWithCommas, fomratWithCommasAndDecimals } from "../../../../shared/util/currencyUtils";
import { CustomerPolicyDetailLabels as cstPolicyCoverageLabel } from '../../../../shared/util/label';
import { PolicySummaryErrorMessages, CUSTOMER_POLICY_LOBCodeId } from "../../../../shared/util/constant";
import { useConfirmationModalContext } from "../../../../shared/components/ModalConfirmationContext";
import { SelectOption } from "../../../../shared/components/input";
import LookupService from "../../../../Services/LookupService";
import { FaChevronDown, FaChevronRight } from "react-icons/fa";
import { IconType } from "../../../../components/components/Icon/interfaces";

export default class CustomerBasicCoverageService {
    private handleRowExpandToggle(
        dtEventArgs: DataTableEventArgs,
        onRowClick: any,
        onCancelClick: () => void
    ) {
        const { rowData, dataTableState, eventData } = dtEventArgs;
        const { rowsState } = dataTableState;
        const rowKey = rowData[dataTableState.dataTable.keyColumnName];
        let currentRowState = rowsState[rowKey];


            if (!currentRowState) {
                currentRowState = { expanded: eventData.expand };
            } else {
                currentRowState = { ...currentRowState, expanded: eventData.expand };
            }

            if (!currentRowState.expanded && !dataTableState.dataTable.isFormSaved) {
                rowsState[rowKey] = { expanded: true };
                dataTableState.dataTable.setExpandedRowId(rowKey);
                rowsState[rowKey] = { expanded: false };
                dataTableState.dataTable.setExpandedRowId(rowKey);
            }

            rowsState[rowKey] = { expanded: currentRowState.expanded };

            dataTableState.dataTable.setExpandedRowId(
                currentRowState.expanded ? rowKey : null
            );

            if (currentRowState.expanded) {
                onRowClick(rowData, dtEventArgs.column);
            } else {
                onCancelClick();
            }
        
    }
    getCoverageTableColumns = (onRowClick: any, onCancelClick: () => void, onRowDeleteClick?: any, deductibleTypesOptions?: SelectOption[], isCoverages?: boolean, lobCodeId?: string, tbIndex?: number): ITableColumn[] => {
    const isEarthquake = Array.isArray(CUSTOMER_POLICY_LOBCodeId.EARTHQUAKE) 
      ? CUSTOMER_POLICY_LOBCodeId.EARTHQUAKE.includes(lobCodeId) 
      : lobCodeId === CUSTOMER_POLICY_LOBCodeId.EARTHQUAKE;
    const modalContext = useConfirmationModalContext();

    const commonStartColumns: ITableColumn[] = [
        {
            tabIndex: tbIndex,
        width: '5%',
        maxWidth: '5%',
        cellTemplate: DataTableDefaultCellTemplates.RowExpander.CellTemplate,
        cellClickHandler: async (dtEventArgs: DataTableEventArgs) => {
            this.handleRowExpandToggle(dtEventArgs, onRowClick, onCancelClick);
        },
        cellTdClassName: 'expander-cell-td',
            onKeyDownHandler: (dtEventArgs: DataTableEventArgs) => {
                const { eventData } = dtEventArgs;
                if (eventData.code === "Enter" || eventData.key === "Enter" || eventData.code === "Space" || eventData.key === " ") {
                    if (!eventData.target.classList.contains('chevron-disabled')) {
                        eventData.expand = true;
                        this.handleRowExpandToggle(dtEventArgs, onRowClick, onCancelClick);
                    }
                }
            }
      },
      {
         header: isCoverages ? cstPolicyCoverageLabel.BASIC_COVERAGE: cstPolicyCoverageLabel.ENDORSEMENT,
        field: "coverageCode",
        width: "20%",
        cellTdContentClassName: "",
        cellTemplate: (rowData, column, rowIndex) => (
          <div><span title={rowData.coverageCode}>{rowData.coverageCode}</span></div>
        )
      },
      {
        header: cstPolicyCoverageLabel.Limit_1,
        field: "limit1",
        width: isCoverages && !isEarthquake? "12%" : isEarthquake ? "18%" : "15%",
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => (
          <div><span title={rowData.limit1}>{formatWithCommas(rowData.limit1)}</span></div>
        )
      },
      {
        header: cstPolicyCoverageLabel.Limit_2,
        field: "limit2",
        width: isCoverages && !isEarthquake? "12%" : isEarthquake ? "18%" : "15%",
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => (
          <div><span title={rowData.limit2}>{formatWithCommas(rowData.limit2)}</span></div>
        )
      },
      ...(isEarthquake ? [
        {
          header: cstPolicyCoverageLabel.EARTHQUAKE,
          field: "deductible1",
          width: "20%",
          cellTdContentClassName: "right-align",
          headerClassName: "right-align-header",
          cellTemplate: (rowData, column, rowIndex) => {
            const value = rowData.deductible1 || '';
            return (
              <div><span title={value}>{value}</span></div>
            );
          }
        }
      ] : [      
      {
        header: cstPolicyCoverageLabel.DED_TYPE_AMT1,
        field: "deductible1",
        width: isCoverages ? "15%" : "20%",
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => {
          const typeLabel = deductibleTypesOptions?.find(opt => opt.value === rowData.deductibleType1)?.label || '';
          const amount = rowData.deductible1 || '';
          return (
            <div><span title={typeLabel}>{this.getDeductibleDisplayText(typeLabel, amount)}</span></div>
          );
        }
      }
    ])
    ];

    const coverageSpecificColumns: ITableColumn[] = isEarthquake ? [] : [
      {
        header: cstPolicyCoverageLabel.DED_TYPE_AMT2,
        field: "deductible2",
        width: "12%",
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => {
          const typeLabel = deductibleTypesOptions?.find(opt => opt.value === rowData.deductibleType2)?.label || '';
          const amount = rowData.deductible2 || '';
          return (
            <div><span title={typeLabel}>{this.getDeductibleDisplayText(typeLabel, amount)}</span></div>
          );
        }
      },
      {
        header: cstPolicyCoverageLabel.DED_TYPE_AMT3,
        field: "deductible3",
        width: "12%", 
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => {
          const typeLabel = deductibleTypesOptions?.find(opt => opt.value === rowData.deductibleType3)?.label || '';
          const amount = rowData.deductible3 || '';
          return (
            <div><span title={typeLabel}>{this.getDeductibleDisplayText(typeLabel, amount)}</span></div>
          );
        }
      }
    ];
    const commonEndColumns: ITableColumn[] = [
            {
        header: cstPolicyCoverageLabel.Premium,
        field: "fullTermPremium",
        width: isCoverages && !isEarthquake ? "12%" : isEarthquake ? "24%" : "20%",
        cellTdContentClassName: "right-align",
        headerClassName: "right-align-header",
        cellTemplate: (rowData, column, rowIndex) => (
          <div><span title={rowData.fullTermPremium}>{fomratWithCommasAndDecimals(rowData.fullTermPremium)}</span></div>
        )
      },
      {
        tabIndex: tbIndex,
        width : '5em',
          maxWidth: '5em',
          cellTemplate: DataTableDefaultCellTemplates.DeleteCellTemplate.CellTemplate,
          cellClickHandler: (dtEventArgs: DataTableEventArgs) => onRowDeleteClick(dtEventArgs.rowData, dtEventArgs.column),
          onKeyDownHandler: (dtEventArgs: DataTableEventArgs) => {
              const { eventData } = dtEventArgs;
              if (eventData.code === "Enter" || eventData.key === "Enter" || eventData.code === "Space" || eventData.key === " ") {
                  onRowDeleteClick(dtEventArgs.rowData, dtEventArgs.column);
              }
          }
      }
    ];

      return [
      ...commonStartColumns,
      ...(isCoverages && !isEarthquake ? coverageSpecificColumns : []),
      ...commonEndColumns
    ];
  }

  private getDeductibleDisplayText = (deductibleType: string, deductibleAmount: number): string => {
    let displayValue = '';
    if (deductibleType && deductibleAmount) {
      displayValue = `${deductibleType}/ ${formatWithCommas(deductibleAmount)}`;
    } else if (deductibleType) {
      displayValue = deductibleType;
    } else if (deductibleAmount) {
      displayValue = formatWithCommas(deductibleAmount);
    }
    return displayValue;
  }

  public getDeductibleTypes = async (): Promise<SelectOption[]> => {
      const deductibleTypesResponse = await LookupService.fetchDeductibleTypes();
      let formattedDeductibleTypes = deductibleTypesResponse?.map(item => ({
          label: item.lookupValue,
          value: item.id
      })) || [];
    return formattedDeductibleTypes;
  }
}